import React from "react";
import { IconProps } from "./IconProps";

const MagnifyingGlassIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.9422 17.0578L14.0305 13.1469C15.1642 11.7857 15.7296 10.0398 15.6089 8.27244C15.4883 6.50506 14.6909 4.85223 13.3826 3.65779C12.0744 2.46334 10.356 1.81926 8.58492 1.85951C6.81388 1.89976 5.12653 2.62125 3.87389 3.87389C2.62125 5.12653 1.89976 6.81388 1.85951 8.58492C1.81926 10.356 2.46334 12.0744 3.65779 13.3826C4.85223 14.6909 6.50506 15.4883 8.27244 15.6089C10.0398 15.7296 11.7857 15.1642 13.1469 14.0305L17.0578 17.9422C17.1159 18.0003 17.1848 18.0463 17.2607 18.0777C17.3366 18.1092 17.4179 18.1253 17.5 18.1253C17.5821 18.1253 17.6634 18.1092 17.7393 18.0777C17.8152 18.0463 17.8841 18.0003 17.9422 17.9422C18.0003 17.8841 18.0463 17.8152 18.0777 17.7393C18.1092 17.6634 18.1253 17.5821 18.1253 17.5C18.1253 17.4179 18.1092 17.3366 18.0777 17.2607C18.0463 17.1848 18.0003 17.1159 17.9422 17.0578ZM3.125 8.75C3.125 7.63748 3.4549 6.54994 4.07298 5.62491C4.69106 4.69989 5.56957 3.97892 6.5974 3.55317C7.62524 3.12743 8.75624 3.01604 9.84738 3.23308C10.9385 3.45012 11.9408 3.98585 12.7275 4.77252C13.5141 5.55919 14.0499 6.56147 14.2669 7.65261C14.484 8.74376 14.3726 9.87476 13.9468 10.9026C13.5211 11.9304 12.8001 12.8089 11.8751 13.427C10.9501 14.0451 9.86252 14.375 8.75 14.375C7.25866 14.3733 5.82888 13.7802 4.77435 12.7256C3.71981 11.6711 3.12665 10.2413 3.125 8.75Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.7973 19.8188L16.469 15.4914C17.7236 13.9852 18.3491 12.0534 18.2156 10.0978C18.0821 8.14224 17.1998 6.31339 15.7522 4.99175C14.3046 3.67011 12.4032 2.95743 10.4436 3.00197C8.48394 3.0465 6.6169 3.84483 5.23087 5.23087C3.84483 6.6169 3.0465 8.48394 3.00197 10.4436C2.95743 12.4032 3.67011 14.3046 4.99175 15.7522C6.31339 17.1998 8.14224 18.0821 10.0978 18.2156C12.0534 18.3491 13.9852 17.7236 15.4914 16.469L19.8188 20.7973C19.883 20.8616 19.9593 20.9126 20.0433 20.9473C20.1272 20.9821 20.2172 21 20.3081 21C20.3989 21 20.4889 20.9821 20.5729 20.9473C20.6568 20.9126 20.7331 20.8616 20.7973 20.7973C20.8616 20.7331 20.9126 20.6568 20.9473 20.5729C20.9821 20.4889 21 20.3989 21 20.3081C21 20.2172 20.9821 20.1272 20.9473 20.0433C20.9126 19.9593 20.8616 19.883 20.7973 19.8188ZM4.40222 10.6262C4.40222 9.39525 4.76726 8.1919 5.45116 7.16836C6.13506 6.14483 7.10712 5.34708 8.24441 4.876C9.38171 4.40492 10.6331 4.28166 11.8405 4.52182C13.0478 4.76197 14.1568 5.35475 15.0273 6.2252C15.8977 7.09564 16.4905 8.20466 16.7307 9.412C16.9708 10.6193 16.8476 11.8708 16.3765 13.0081C15.9054 14.1454 15.1077 15.1174 14.0841 15.8013C13.0606 16.4852 11.8572 16.8503 10.6262 16.8503C8.97609 16.8484 7.39405 16.1921 6.22722 15.0253C5.06038 13.8584 4.40405 12.2764 4.40222 10.6262Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.75 14C4.75 8.89137 8.89137 4.75 14 4.75C19.1086 4.75 23.25 8.89137 23.25 14C23.25 19.1086 19.1086 23.25 14 23.25C8.89137 23.25 4.75 19.1086 4.75 14ZM14 3.25C8.06294 3.25 3.25 8.06294 3.25 14C3.25 19.9371 8.06294 24.75 14 24.75C16.6986 24.75 19.165 23.7556 21.0527 22.1133L27.4697 28.5304C27.7626 28.8233 28.2375 28.8233 28.5304 28.5304C28.8233 28.2375 28.8233 27.7626 28.5304 27.4697L22.1133 21.0527C23.7556 19.165 24.75 16.6986 24.75 14C24.75 8.06294 19.9371 3.25 14 3.25Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default MagnifyingGlassIcon;
